import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTimecardTotalsQuickInfo extends Layout {
    labelHoliday: Label;
    labelHours: Label;
    labelOvertime: Label;
    labelPayRate: Label;
    labelRegular: Label;
    labelSick: Label;
    labelTotal: Label;
    labelVacation: Label;
    panelHoliday: Panel;
    panelLeftHeaders: Panel;
    panelOvertime: Panel;
    panelRegular: Panel;
    panelSick: Panel;
    panelVacation: Panel;
    sourceDrsTimecard: DataSource;
    textboxAddlTaxOverrideHours: Textbox;
    textboxHolidayTotal: Textbox;
    textboxHolidayUnits: Textbox;
    textboxId: Textbox;
    textboxOvertimeRate: Textbox;
    textboxOvertimeTotal: Textbox;
    textboxOvertimeUnits: Textbox;
    textboxPaymentFrequency: Textbox;
    textboxRegularRate: Textbox;
    textboxRegularRateHoliday: Textbox;
    textboxRegularRateSick: Textbox;
    textboxRegularTotal: Textbox;
    textboxRegularUnits: Textbox;
    textboxSickTotal: Textbox;
    textboxSickUnits: Textbox;
    textboxVacationRate: Textbox;
    textboxVacationTotal: Textbox;
    textboxVacationUnits: Textbox;
}
